import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { scheduleAService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type scheduleAHistoryProps = {
	historyKey: string;
	fetchData: {
		page: number;
	};
	id: number;
};

const useGetScheduleAHistoryQuery = ({
	historyKey,
	fetchData,
	id,
}: scheduleAHistoryProps) => {
	const dispatch = useDispatch();

	const { page } = fetchData || {};

	return useQuery(
		[historyKey, page],
		() => scheduleAService.getScheduleAHistory({ page, id }),
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!id,
			cacheTime: 0,
		},
	);
};

export default useGetScheduleAHistoryQuery;
